import { Link } from "react-router";
import { Banner } from "../../components/Banner/Banner.tsx";
import { FireIcon } from "../../components/icons/Fire.tsx";

export const Home = () => {
  return (
    <div className="home-container">
      <Banner
        title="TIMBER WITH STYLE"
        subtitle="Techniques that have lasted centuries inspired by ancient Japan"
        showcase
      />
      <span className="h2 content-padding centered bottom-padding">
        About Us
      </span>

      <div className="centered bottom-padding">
        <img
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/published/graphic_1.png?1710944303"
          alt="Dividing graphic"
        />
      </div>

      <div className="content centered content-padding bottom-padding">
        <span>
          Welcome to Charproof, New Zealand's premium commercial timber charring specialist. 
          Drawing inspiration from the traditional Japanese techniques of <i>Shou sugi ban</i>, <i>yaki sugi</i>, and <i>yaki-ita</i>, 
          we bring innovation and expertise to the art of timber charring. While these terms originated in Japan, they have become widely 
          adopted in the Western market to describe the process of charring timber.
        </span>
      </div>

      <div className="content centered content-padding bottom-padding">
        <span>
          At Charproof, we understand the profound benefits that charring timber can add to its molecular structure. 
          From enhanced protection against weather elements, fungi, and bug infestation to increased structural density and 
          resistance to UV damage, our charred timber solutions offer unparalleled durability, especially suited to New Zealand's challenging 
          weather conditions.
        </span>
      </div>

      <div className="content centered content-padding bottom-padding">
        <span>
          Our mission at Charproof is to honor the rich tradition of charring timber while revolutionising its efficiency and 
          offering one of a kind natural timber finishes customised to suit individual preferences.
        </span>
      </div>

      <div className="content centered content-padding bottom-padding">
        <span>
          While our focus lies on exterior cladding for homes, the versatility of our traditional burnt timber finish makes it 
          suitable for a wide range of projects. Whether you seek a classic look or desire to infuse your style with a unique flair, 
          our specialised stains, available in a select range of colours, allow us to tailor the charring finish to match your vision.
        </span>
      </div>

      <div className="content centered content-padding bottom-padding">
        <span>
          Join us at Charproof where tradition meets innovation, and let us elevate your project to new heights of style while also lasting the test of time in our brutal weather.
        </span>
      </div>

      <span className="content centered content-padding bottom-padding-large">
        <FireIcon />
      </span>

      <span className="h2 content-padding bottom-padding-small">
        Our Finishes
      </span>
      <div className="content content-padding bottom-padding">
        <span>
          These samples in <i>Larch</i> are as following:
        </span>
      </div>

      <div className="finish-gallery content-padding bottom-padding-extra-large">
        <Link to="/finishes#full-char" className="finish-gallery__item">
          <div
            className="finish-gallery__item__image"
            style={{
              backgroundImage:
                "url('https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-15_orig.jpg')",
            }}
          />
          <span>Full Charred (Crocodile Skin / textured)</span>
        </Link>


        <Link
          to="/finishes#charred-and-brushed"
          className="finish-gallery__item"
        >
          <div
            className="finish-gallery__item__image"
            style={{
              backgroundImage:
                "url('https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-17_orig.jpg')",
            }}
          />
          <span>Charred and Brushed (Smooth / visual grain)</span>
        </Link>

        <Link to="/finishes#double-brushed" className="finish-gallery__item">
          <div
            className="finish-gallery__item__image"
            style={{
              backgroundImage:
                "url('https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-18_orig.jpg')",
            }}
          />
          <span>
            Double Brushed (Snake Skin / deep and strong grain visuals)
          </span>
        </Link>
      </div>

      <span
        className="h3 content-padding bottom-padding content centered"
      >
        Whats our secret to great Charred timber?
      </span>

      <span
        className="content-padding bottom-padding content centered"
      >
        We have our in-house specially selected deep penetration hardening stain, this adds a protective water resistant coat to the charred surface making it incredibly durable, stable and hard wearing for even longer! No soot or charring will rub off! Which makes it a unique and desirable "high traffic zone", product.
      </span>

      <span
        className="content-padding bottom-padding content centered"
      >
        We hold a range of colours that can be added in with our special deep penetration hardening stain for your own personalised look.
      </span>

      <span
        className="content-padding bottom-padding content centered"
      >
        All charred timber over time will naturally wear from weather but at Charproof we try our best to keep your timber lasting the longest by offering a recommended maintainance guide. Also offering a restaining service option to help keep your charred timber fresh for longer. This maintains the fresh deep black look.
      </span>

      <div className="content-padding bottom-padding-large content centered">
        <span
          >
          We work closely with our suppliers to have direct warehouse access to premium A-B grade imported <i>Larch (Larix Sibirica)</i> with incredibly competitive rates to imported and locally sourced cedar. Locally Kiln dried, graded and 
          processed to any specified profile in Christchurch, New Zealand. We highly recommend the 
          charred Larch to be a fantastic choice to withstand the harsh New Zealand conditions. 
          Including north facing applications. <br />Due to different profiles and grades of timber available, <u>POA.</u>
        </span>
      </div>

      <span className="content centered content-padding bottom-padding-large">
        <FireIcon />
      </span>

      <div className="content-padding bottom-padding-small content centered">
        <span className="h3">
          <u>About Larch (Larix Sibirica)</u>
        </span>
      </div>

      <div className="content-padding bottom-padding content centered">
        <span>
          Due to the extremely cold weather where our timber is sourced from. Our Larch is Highly frost-hardy and thrives in boreal zones, often forming tree lines. The tight hartwood and sapwood grain structure has amazing strength and durability properties.
        </span>
      </div>
      <div className="content-padding bottom-padding-extra-large content centered">
        <span>
          This rot resistant timber is very popular in Europe, Mongolia, China. It charrs beautifully with its "Cedar-like" grain patterns and occasional knots that shine with character.<br/><br />
          With its tight rings - comes amazing stability, durability, and structural characteristics including water resistance, the <i>Larch</i> surpasses the criteria for New Zealand building standards by a long shot.
        </span>
      </div>


      <Link to="/gallery">
        <Banner
          backgroundImageUrl="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-19_orig.jpg"
          title="View some of our projects in our Gallery here"
          centered
          fitContent
        />
      </Link>
      <br className="bottom-padding-large" />
    </div>
  );
};
